import { Service, inject } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {GoogleService} from "./google-service";
import {Observable} from "rxjs";
import {OrgunitXProjectProductType} from "../organization/organization-brands/orgunit-x-projectproducttype";
import {ProjectProductType} from "../enums/project-product-type";
import {BrandID} from "../enums/brand-id";
import {OrgunitXPricelist} from "../organization/organization-brands/orgunit-x-pricelist";

@Service()
export class OrganizationPricelistService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getOrgUnitXPriceList(orgUnitId: string, projectProductType: ProjectProductType, brandID: BrandID): Observable<OrgunitXPricelist> {
    let url = this.urlBase + 'orgunitpricelist/' + orgUnitId + '/' + projectProductType + '/' + brandID;
    return this.http.get<OrgunitXPricelist>(url, {headers: this.getHeaders()});
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
